module.exports = __webpack_public_path__ + "static/media/README.02af73ec.md";